import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { AndarDBService } from '../database/andar-db.service';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class AndarService extends BaseService{
    override classname: string = 'AndarService';
    public override route = 'andar';
    public override database = Capacitor.isNativePlatform() ? new AndarDBService() : new AndarDBService();
}
